import apolloClient from "../apollo";
import getSerialNumberByCode, {
	readSerialNumberByCode,
} from "../graphql/queries/getSerialNumberByCode";

/** @type {(context: object, serialNumber: string) => Promise<object | null>} */
export const getSerialNumberInfo = (context, serialNumber) =>
	serialNumber
		? apolloClient(context)
				.query({
					query: getSerialNumberByCode,
					variables: { serialNumber },
				})
				.then(readSerialNumberByCode)
		: Promise.resolve(null);
